var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 60.0001V95.0001M60 60.0001L47.5 70.0001M60 60.0001L72.5 70.0001M25.1701 45.5851C20.4411 46.775 16.3094 49.6509 13.5513 53.6723C10.7932 57.6937 9.59846 62.5839 10.1916 67.424C10.7847 72.2642 13.1249 76.7212 16.7724 79.9576C20.4199 83.1941 25.1237 84.9872 30.0001 85.0001H35.0001",
    stroke: "#36A0F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1513 35.6901C77.4423 28.9229 73.2242 23.0588 67.3519 19.2863C61.4797 15.5139 54.3927 14.1155 47.5276 15.3746C40.6625 16.6336 34.533 20.456 30.3816 26.0667C26.2302 31.6775 24.3676 38.6569 25.1713 45.5901C25.1713 45.5901 25.9363 50.0001 27.5013 52.5001",
    stroke: "#36A0F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85 85C88.5302 84.9976 92.0199 84.2476 95.2393 82.7993C98.4587 81.351 101.335 79.2373 103.679 76.5974C106.022 73.9574 107.78 70.851 108.837 67.4826C109.894 64.1143 110.225 60.5603 109.809 57.0547C109.393 53.5491 108.239 50.1713 106.424 47.1437C104.609 44.1161 102.172 41.5072 99.2762 39.4889C96.3799 37.4706 93.0889 36.0886 89.62 35.4338C86.151 34.779 82.5828 34.8663 79.15 35.69L72.5 37.5",
    stroke: "#36A0F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.fb59fd7a82efe3681db9b57744c8615e.svg";
export { ForwardRef as ReactComponent };